// Centralized 2Life Travel branding tokens
// Import this wherever you need consistent colors or fonts.

export const BRAND = {
  maroon: '#7A1B3E',
  maroonLight: '#9B2D54',
  taupe: '#A89A8C',
  taupeLight: '#C4B8AD',
  cream: '#F5F0EB',
  dark: '#1A1A1A',
  gold: '#C9A96E',
}

export const FONTS = {
  heading: "'Cormorant Garamond', serif",
  body: "'Montserrat', sans-serif",
}

